import { BarChart } from "react-feather";

export enum ReportTabKey {
  TRADE_DATA = 'TRADE_DATA'
}

export const TABS_REPORT: ITabSetting[] = [
  {
    key: ReportTabKey.TRADE_DATA,
    label: 'Trade Data',
    icon: BarChart,
    disable: false,
  },
];
